<template>
  <div class="packingWork" v-if="pickInfo">
    <!--面包屑-->
    <div class="breadcrumb_box">
      <Breadcrumb>
        <BreadcrumbItem v-for="(item, index) in breadcrumbList" :key="index" :to="item.path ? item.path : ''">{{ item.name }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 当前拣货单 -->
    <div class="pickHeader clearfix">
      <div>
        <Row>
          <Col span="15">
            <div style="fontSize:16px;marginLeft:10px;height: 40px;">
              {{ $t('key1004891') }}<span style="font-weight: bold;">{{ pickInfo.code }} {{ pickInfo.skuQuantity > 1 ? $t('key1000202') : $t('key1000203') }}</span>
            </div>
          </Col>
          <Col span="9">
            <div class="fr" style="display: inline-block;float: right;margin-right: 10px;">
              <div style="fontSize:16px;marginLeft:10px;font-weight: bold;color: #fff;height: 40px;display: inline-block">
                {{ $t('key1004892') }}{{ userName }}
              </div>
              <Button size="small" style="marginLeft:30px;" v-if="getPermission('ymsPickingOrder_quitPacking')"
                @click="isOpenQuitModal(1)">{{ $t('key1004893') }}</Button>
              <Button size="small" style="marginLeft:30px;" v-if="getPermission('ymsPickingOrder_quitPacking')"
                @click="isOpenQuitModal(2)">{{ $t('key1004870') }}</Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <!-- content -->
    <div class="">
      <Row>
        <div class="skuInput wid100P flex align-items-center justify-content-between">
          <!-- 输入sku开始分拣 -->
          <div class="font-size-18 font-weight-bold color-white">
            <span>{{ $t('key1004821') }}</span>
            <Input
              ref="sortingSku"
              v-model.trim="skuInput"
              :disabled="packageProcessStep === 3"
              :element-id="'sortingSku'"
              style="width:300px;marginLeft:15px;"
              @on-enter="clearSku();skuStart()">
            </Input>
          </div>
          <Button
            size="small"
            class="mr20"
            @click="$refs['printingSize'].initPrintingSizeData('packagePrintSize', packagePrintSizeObj)">
            {{ $t('key1001280') }}
          </Button>
        </div>
      </Row>
      <Row>
        <Col class="packProcessCol">
          <div class="packProcess">
            <Steps :current="packageProcessStep">
              <Step :title="$t('key1004883')" icon="ios-person"></Step>
              <Step :title="$t('key1004884')" icon="ios-person"></Step>
              <Step :title="$t('key1004885')" icon="ios-person"></Step>
              <Step :title="$t('key1004886')" icon="ios-person"></Step>
              <Step :title="$t('key1004887')" icon="ios-person"></Step>
            </Steps>
          </div>
        </Col>
      </Row>
      <Row align="middle" type="flex" class="bar">
        <Col :span="8">
          {{ $t('key1004894') }}{{ packageCode }}
        </Col>
      </Row>
      <div class="scanPackageShow">
        <Row justify="center" align="middle" type="flex">
          <Col span="16">
            <!-- 扫描货品信息 -->
            <div class="skuBox">
              <div class="orderTable">
                <Table
                  border
                  :loading="tableLoading"
                  :height="440"
                  :columns="currentPackageColumn"
                  :data="currentPackageData"></Table>
              </div>
              <div class="mt10">
                <a href="#" @click="clearScan()" v-if="getPermission('ymsPickingOrderRelated_resetWaitingPacked')"
                  class="cleanScanLink">{{ $t('key1004895') }}</a>
              </div>
            </div>
          </Col>
          <!-- 货品信息 -->
          <Col span="8">
            <div v-show="showSku">
              <!-- 货品信息 -->
              <div class="productInfo">
                <Row justify="center" align="middle" type="flex">
                  <Col>
                    <Tooltip placement="left" theme="light" :transfer="true" transfer-class-name="set_bigimg_style">
                      <img class="img_styles" :src="setImgPath(productImg)" @error="setErrorImg($event)" alt=""/>
                      <template #content>
                        <img :ref="'thumbnailImg'" @load="handlerOnloadImg('thumbnailImg')"
                          :src="setImgPath(productImg)" @error="setErrorImg($event)" alt=""/>
                      </template>
                    </Tooltip>
                  </Col>
                </Row>
                <Row justify="center" align="middle" type="flex">
                  <div style="fontSize:22px;marginTop:20px;">
                    SKU：<span style="color:#008000;">{{ sku }}</span>
                  </div>
                </Row>
                <Row justify="center" align="middle" type="flex">
                  <div style="fontSize:22px;marginTop:20px;">
                    {{ $t('key1002424') }}<span style="color:#008000;">{{ title }}</span>
                  </div>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <Row class="bar">
        <Col>
          {{ $t('key1004896') }}
        </Col>
      </Row>
      <div class="pl12 pr12 pb20">
        <Table
          border
          :loading="tableLoading"
          :height="550"
          :columns="printedPackageColumn"
          :data="pickInfo.ymsPickingOrderRelatedList"
          @on-selection-change="changeData">
        </Table>
      </div>
    </div>
    <!-- sku输入异常 -->
    <Modal v-if="warnModalStatus" v-model="warnStatus" :title="$t('key1004888')" width="500">
      <!--一个隐藏的input，用于回车时，关闭弹窗-->
      <Input :element-id="'skuAbnormal'" ref="skuAbnormal" @on-enter="hideSkuModal"
        style="opacity: 0;position: absolute;top: 50px;left: 0; z-index: -10;">
      </Input>
      <div style="padding:10px 20px;">
        <Row>
          <Col span="6">
            <div>
              <Icon type="md-information-circle" color="#2b85e4" style="font-size:50px"></Icon>
            </div>
          </Col>
          <Col
            span="16"
            v-if="findWarnStatus"
            style="font-size:16px">{{ $t('key1004889').replace('{warnSku}', sku) }}
          </Col>
          <Col span="16" v-if="warnPrintStatus" style="font-size:16px">{{ $t('key1004897') }}</Col>
          <Col span="16" v-if="warnMatchStatus" style="font-size:16px">
            <div>{{ $t('key1004898') }}</div>
            <div style="marginTop:3px;">
              {{ $t('key1004899') }}
            </div>
            <div style="marginBottom:15px;">
              {{ $t('key1004900') }}
            </div>
          </Col>
          <Col span="16" v-if="errorCode === 111183" style="font-size:16px">{{ $t('key1004901') }}</Col>
          <Col span="16" v-if="errorCode === 116101" style="font-size:16px">{{ $t('key1004902') }}</Col>
          <Col span="16" v-if="errorCode === 116102" style="font-size:16px">{{ $t('key1004903') }}</Col>
          <Col span="16" v-if="errorCode === 116114" style="font-size:16px">{{ $t('key1004904') }}</Col>
          <Col span="16" v-if="errorCode === 116113" style="font-size:16px">{{ $t('key1004905') }}</Col>
          <Col span="16" v-if="errorCode === 116118" style="font-size:16px">{{ $t('key1004906') }}</Col>
          <Col span="16" v-if="errorCode === 111183" style="font-size:16px">{{ $t('key1004890') + configCharacters() + $t('key1001887') }}</Col>
        </Row>
      </div>
      <template #footer>
        <Button style="marginRight:210px;" @click="cancel">{{ $t('key1000732') }}</Button>
      </template>
    </Modal>
    <!-- 结束作业 -->
    <endWarnModal
      ref="endWarnModal"
      :pickInfo="pickInfo"
      :userData="userData"
      :pickingGoodsNo="pickingGoodsNo"
      :pickingGoodsId="pickingGoodsId"
      :currentPackageData="currentPackageData"></endWarnModal>
    <!--订单取消提示-->
    <orderCancelPromptModal ref="orderCancelPrompt" @updateData="initFun"></orderCancelPromptModal>
    <!--打印配置弹窗-->
    <printingSizeModal ref="printingSize" @updatePrintSet="updatePrintSet"></printingSizeModal>
    <!--打印合规标签弹窗-->
    <printComplianceLabelsModal ref="printComplianceLabels"></printComplianceLabelsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import endWarnModal from './endWarnModal';
import {getErpconfig} from '@/utils/user';
import orderCancelPromptModal from "@/components/common/orderCancelPromptModal";
import printingSizeModal from "@/components/common/printingSizeModal";
import {
  downloadControl, getUserNameByUserId, ymsVerifyPicking, qs, getCommonSetting, getCommonParamKeysData,
  getQueryCarrierShippingName, getAllUsersInfo, printHtmlUrl, commonLocalStorage
} from "@/utils/common";
import printComplianceLabelsModal from "@/components/common/printComplianceLabelsModal.vue";

export default {
  mixins: [Mixin],
  components: {
    printComplianceLabelsModal,
    endWarnModal,
    orderCancelPromptModal,
    printingSizeModal
  },
  data() {
    var self = this;
    return {
      pickInfo: null,
      userData: [],
      reviewPackaging: true,
      ymsPickingOrderRelatedId: null,
      errorCode: 0,
      scanSkuPackageId: '',
      filenodeViewTargetUrl: localStorage.getItem('imgUrlPrefix'),
      pickingGoodsNo: '',
      pickingGoodsId: '',
      packageGoodsTypeName: '',
      packageGoodsType: '',
      pickingGoodsWeighting: null, // 是否称重
      userId: '',
      labelTypeText: '',
      packageCode: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004872'),
      printPackageCode: '',
      labelPath: '', // 该包裹的打印pdf地址
      platformProductLabelPath: null, // 速卖通全托管货品标签面单
      orderType: null, // 订单类型
      productImg: null, // 当前货品的图片
      title: '', // 当前货品名称
      variations: '', // 当前货品规格
      quantity: null, // 当前货品应发数量
      packageProcessStep: 0,
      pickData: [], // 拣货单数据
      sku: null, // 输入sku
      skuInput: null, // 输入的sku
      warnSku: null, // 异常sku
      warnStatus: false, // 控制是否显示异常警告
      findWarnStatus: false, // 查询sku警告
      warnPrintStatus: false, // 控制是否显示待打印警告
      warnMatchStatus: false, // 控制是否显示匹配异常错误
      warnModalStatus: false, // 是否生成模态框
      printedPackageData: [],
      scanSkuParams: {
        ymsPickingOrderId: null,
        skus: []
      },
      printedPackageColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'NO.',
          width: 80,
          align: 'center',
          key: 'index',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000156'),
          key: 'packageCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004873'),
          key: 'merchantShippingMethodId',
          align: 'center',
          render: (h, params) => {
            if (params.row._shipInfo) {
              return h('div', [h('div', params.row._shipInfo.carrierCode), h('div', params.row._shipInfo.carrierName)]);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004741'),
          key: 'isPrinted',
          align: 'center',
          render: (h, params) => {
            if (params.row.packedStatus === 3 || params.row.isPrinted) {
              return h('Icon', {
                props: {
                  type: 'md-checkmark-circle',
                  size: '20'
                },
                style: {
                  color: '#008000'
                }
              });
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          align: 'center',
          render(h, params) {
            return h('span', params.row.ymsPackageInfo.trackingNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004874'),
          key: 'sku',
          align: 'center',
          render: (h, params) => {
            let pos = [];
            let goods = params.row.ymsPackageInfo.ymsPackageGoods;
            if (goods) {
              goods.forEach((n, i) => {
                pos.push(h('div', n.sku + ' * ' + n.quantity));
              });
              return h('div', pos);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          render(h, params) {
            let ymsPackageInfo = params.row.ymsPackageInfo || null;
            if (ymsPackageInfo) {
              let orderType = ymsPackageInfo.orderType;
              let platformProductLabelPath = ymsPackageInfo.platformProductLabelPath;
              let packageCode = params.row.packageCode;
              let isProductLabelPath = ymsPackageInfo.isProductLabelPath;
              return h('optsButtonList', {
                props: {
                  operationList: [
                    {
                      text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004875'),
                      show: orderType === 'ONE_STOP_SERVICE',
                      clickFn: () => {
                        if (Object.keys(self.packagePrintSizeObj).length > 0) {
                          self.goodsLabelSize = `${self.packagePrintSizeObj.goodsWidth}*${self.packagePrintSizeObj.goodsHeight}`;
                        }
                        // 速卖通全托管
                        if (platformProductLabelPath) {
                          self.print(platformProductLabelPath, packageCode, true, null, null, self.goodsLabelSize, 'ONE_STOP_SERVICE');
                        } else {
                          self.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004876'));
                          return false;
                        }
                      }
                    },
                    {
                      text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000323'),
                      show: isProductLabelPath === 1 && self.orderComplianceLabelVerificationTalg,
                      clickFn: () => {
                        self.$refs['printComplianceLabels'].initPrintComplianceLabelsData(ymsPackageInfo);
                      }
                    },
                  ]
                },
                on: {
                  setWidth(value) {
                    if (value) {
                      self.optionBtnWidth.push(value);
                      params.column.width = Math.max(...self.optionBtnWidth);
                      self.$forceUpdate();
                    }
                  }
                }
              })
            }
          }
        },
      ],
      currentPackageData: [],
      currentPackageColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          key: 'index',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004877'),
          key: 'title',
          align: 'center',
          render: (h, params) => {
            if (params.row.variations) {
              return h('span', params.row.name + ' / ' + params.row.variations);
            } else {
              return h('span', params.row.name);
            }
          }
        },
        {
          title: 'SKU',
          key: 'sku',
          align: 'center',
          render: (h, params) => {
            return h('span', {
              style: {
                color: '#008000'
              }
            }, params.row.sku);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004809'),
          key: 'quantity',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004835'),
          key: 'scanQuantity',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.scanQuantity
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  input: value => {
                    params.row.scanQuantity = value;
                    if (!params.row.scanQuantityInputFocus) {
                      self.currentPackageData[params.index].scanQuantity = params.row.scanQuantity;
                    }
                  },
                  'on-focus': () => {
                    params.row.scanQuantityInputFocus = true;
                  },
                  'on-blur': () => {
                    params.row.scanQuantityInputFocus = false;
                    self.currentPackageData[params.index].scanQuantity = params.row.scanQuantity;
                  }
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004878'),
          key: 'check',
          align: 'center',
          render: (h, params) => {
            return self.currentPackageData[params.index].check ? h('span', {
              attrs: {
                class: 'icon iconfont greenColor cursor'
              },
              style: {
                margin: '0 10px'
              }
            }, '') : '';
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
          key: 'operation',
          align: 'center',
          render: (h, params) => {
            return h('Icon', {
              props: {
                type: 'md-close'
              },
              style: {
                margin: '0 10px',
                cursor: 'pointer',
                color: 'red'
              },
              on: {
                click: () => {
                  if (self.currentPackageData.length < 2) {
                    // 单品
                    self.clearScan();
                  } else {
                    self.currentPackageData.splice(params.index, 1);
                  }
                }
              }
            });
          }
        }
      ],
      showSku: true,
      packageWeight: {
        // 重量
        weightUnit: 0,
        weight: null
      },
      weightUnitList: [
        {
          name: 'g',
          value: 0
        }, {
          name: 'kg',
          value: 1
        }
      ],
      weightStatus: true, // 未完成包装前不能称重
      wrappings: {
        name: null,
        value: null
      }, // 包材
      wrappingsList: null, // 包材列表
      showSize: null, // 选择后展示的包材尺寸
      showWeight: null,
      showCost: null,
      showDesc: null,
      userName: null, // 获取操作员name
      userList: [],
      basketNum: 0, // 拣货篮
      basketList: null,
      isEachPiece: true,
      printList: [],
      packageIds: [],
      printStatus: false,
      printObj: null,
      clearTime: null,
      breadcrumbList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004788')},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004789')},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002654'), path: '/wms/packWorking'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004796')}
      ],
      matchYmsPackageInfo: null,
      packagePrintSizeObj: {},
      aliexpressChoiceTalg: false,
      goodsLabelSize: null,
      conventionLabelSize: null,
      logisticsManifestLabelSize: null,
      complianceLabelPackageCode: null,
      productLabelPath: null,
      isPrintComplianceLabels: false, // 是否打印商品合规标签
      userInfoList:{}
    };
  },
  mounted() {
    // 在模态框组件挂载后，监听键盘事件
    document.addEventListener('keydown', this.handleKeyDown);
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun(obj) {
      let v = this;
      (async () => {
        await Promise.all([v.getPackagePrintSizeData(), getErpconfig('')]);
        v.userInfoList = await getAllUsersInfo();
        let data = await v.getPickInfo();
        if (!data) await this.$router.push('/wms/packWorking');
        if (data.ymsWarehouseId) {
          v.getPackageSetting(data.ymsWarehouseId);
        }
        if (data.ymsPickingOrderRelatedList) {
          let shipData = await getQueryCarrierShippingName(data.ymsPickingOrderRelatedList.map(i => i.ymsPackageInfo.shippingMethodId));
          data = v.setViewData(data, shipData);
          this.currentPackageData = v.initCurrentPackageData(data);
          this.pickInfo = data;
          this.pickingGoodsId = data.ymsPickingOrderId;
          v.$nextTick(() => {
            v.getFocus('sortingSku');
          })

          // 开始包装作业之前要校验出库单中是否存在有已取消的订单，如果存在取消的订单则弹出取消订单提示窗
          ymsVerifyPicking(api.put_ymsPickingOrder_checkPickingOrder, [data.ymsPickingOrderId]).then((list) => {
            if (list.length > 0) {
              this.$refs['orderCancelPrompt'].basicData = list;
              this.$refs['orderCancelPrompt'].orderCancelPromptModal = true;
            }
          });
        } else {
          if (obj && obj.allDelete === 1) {
            v.$Modal.info({
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004804'),
              content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004805'),
              okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000732'),
              onOk: () => {
                // v.$refs['endWarnModal'].finishPackWork(1);
                v.$router.push('/wms/packWorking');
              },
            });
          }
        }
      })();
    },
    /**
     * 获取拣货单信息
     * @date: 2021/8/19 11:06
     * @param
     */
    getPickInfo() {
      let v = this;
      let code = v.$route.query.code;
      return new Promise(resolve => {
        v.axios.put(api.put_ymsPickingOrder_startPacking + '?code=' + code).then(response => {
          v.$Spin.hide();
          if (response.data.code === 0) {
            resolve(response.data.datas);
          }
        });
      });

    },
    initCurrentPackageData(response) {
      let v = this;
      return response.ymsPickingOrderRelatedList.reduce((prev, cur) => {
        if (cur.packedStatus === 2) {
          v.packageCode = cur.packageCode;
          v.printPackageCode = cur.packageCode;
          v.packageProcessStep = 2;
          v.ymsPickingOrderRelatedId = cur.ymsPickingOrderRelatedId;
          v.labelPath = cur.ymsPackageInfo.labelPath;
          v.platformProductLabelPath = cur.ymsPackageInfo.platformProductLabelPath;
          v.orderType = cur.ymsPackageInfo.orderType;
          let data = cur.ymsPackageInfo.ymsPackageGoods.map(goods => {
            goods.scanQuantity = goods.quantity;
            return goods;
          });
          return [...prev, ...data];
        } else {
          return prev;
        }
      }, []);

    },
    clearScan() {
      // 清空已扫描货品并重新扫描
      let v = this;
      clearTimeout(v.clearTime);
      if (v.ymsPickingOrderRelatedId) {
        // 已经识别了是哪个包裹
        v.axios.put(api.put_ymsPickingOrderRelated_resetWaitingPacked + v.ymsPickingOrderRelatedId).then(response => {
          if (response.data.code === 0) {
            v.currentPackageData = [];
            v.resetPackageParam();
            v.tableLoading = false;
          }
        });
      } else {
        // 还没找到包裹信息
        v.tableLoading = false;
        v.currentPackageData = [];
      }
    },
    clearSku() {
      this.sku = this.skuInput;
      this.skuInput = '';
      document.getElementById('sortingSku').blur();
    },
    skuStart() {
      // 输入sku开始分拣
      let v = this;
      clearTimeout(v.clearTime);
      v.skuInput = '';
      if (v.packageProcessStep === 3) {
        // 当前有待打印的，不允许sku
        v.warnPrintStatus = true;
        v.warnStatus = true;
        v.warnModalStatus = true;
        document.getElementById('sortingSku').focus();
        return;
      }
      v.warnStatus = false; // 确认警告框是隐藏的
      if (v.sku) {
        let isFirst = true;
        v.pickInfo.ymsPickingOrderRelatedList.forEach(pack => {
          //  1:待包装 2:包装中 3:包装完成'
          if ((pack.packedStatus === 1 || pack.packedStatus === 2) && isFirst) {
            let packCurSkuValid = v.currentPackageData.every(cur => {
              return pack.ymsPackageInfo.ymsPackageGoods.some(goods => goods.sku === cur.sku);
            }); // 当前匹配中的sku 是否都在拣货单中
            let curSkuValid = pack.ymsPackageInfo.ymsPackageGoods.some(goods => {
              if (goods.sku === v.sku) {
                this.sku = goods.sku;
                this.title = goods.title;
                this.productImg = goods.productImg;
                return true;
              }
            }); // 当前sku 是否在拣货单中
            let curHasSku = v.currentPackageData.some(goods => goods.sku === v.sku); // 当前sku 是否在当前包裹中
            if (packCurSkuValid && curSkuValid) {
              if (curHasSku) {
                v.currentPackageData.forEach((curGoods, index) => {
                  if (curGoods.sku === v.sku) {
                    v.$set(v.currentPackageData[index], 'scanQuantity', ++curGoods.scanQuantity);
                  }
                });
              } else {
                let data = JSON.parse(JSON.stringify(pack.ymsPackageInfo.ymsPackageGoods.filter(goods => goods.sku === v.sku)));
                data[0].scanQuantity = 1;
                v.currentPackageData.push(data[0]);
              }
              isFirst = false;
              // 判断匹配完成
              let matchSkuEnd = pack.ymsPackageInfo.ymsPackageGoods.every(goods => {
                let goodsValid = false;
                v.currentPackageData.forEach(p => {
                  if (goods.sku === p.sku && goods.quantity === p.scanQuantity) {
                    goodsValid = true;
                  }
                });
                return goodsValid;
              });
              if (matchSkuEnd && pack.ymsPackageInfo.ymsPackageGoods.length === 1) v.scanSku();
            } else {
              // v.warnModalStatus = true;
              // v.warnStatus = true;
              // v.findWarnStatus = true;
              document.getElementById('sortingSku').focus();
            }
          }
        });
        if (isFirst) {
          v.warnModalStatus = true;
          v.warnStatus = true;
          v.findWarnStatus = true;
          document.getElementById('sortingSku').focus();
        }
      } else {
        if (v.currentPackageData && v.currentPackageData.length) {
          v.scanSku();
        }
      }
      document.getElementById('sortingSku').focus();
    },
    // 多品多件--->需要扫描完sku的时候，需要再操作回车键才会触发调接口
    scanSku() {
      // 调扫描sku匹配包裹的接口
      let v = this;
      if (v.ymsPickingOrderRelatedId) {
        v.matchFinish();
        return;
      }
      v.printStatus = false;
      v.scanSkuParams.ymsPickingOrderId = v.pickInfo.ymsPickingOrderId;
      let skus = [];
      v.currentPackageData.forEach((m, t) => {
        skus.push({
          ymsSku: m.sku,
          quantity: m.scanQuantity
        });
      });
      v.scanSkuParams.skus = skus;
      v.complianceLabelPackageCode = null;
      v.productLabelPath = null;
      v.matchYmsPackageInfo = null;
      v.axios.put(api.put_ymsPickingOrder_matchYmsPackage, JSON.stringify(v.scanSkuParams)).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          v.currentPackageData.forEach((n) => {
            n.check = true;
          });
          v.matchYmsPackageInfo = data;
          v.ymsPickingOrderRelatedId = data.ymsPickingOrderRelatedId;
          v.packageCode = data.packageCode;
          v.printPackageCode = data.packageCode;
          v.labelPath = data.ymsPackageInfo.labelPath;
          v.platformProductLabelPath = data.ymsPackageInfo.platformProductLabelPath;
          v.orderType = data.ymsPackageInfo.orderType;
          v.complianceLabelPackageCode = 'HG-' + data.packageCode;
          v.productLabelPath = data.productLabelPath;
          v.matchFinish();
        } else {
          v.warnStatus = true;
          v.warnModalStatus = true;
          // document.getElementById('sortingSku').focus();
          if (response.data.code === 111183) {
            // 未匹配到指定云卖订单
            v.errorCode = 111183;
          }
        }
      });
    },
    // 已经扫描匹配完成
    matchFinish() {
      let v = this;
      // 调打印
      v.packageProcessStep = 3;
      // 获取设置的打印面单对应的尺寸
      if (Object.keys(v.packagePrintSizeObj).length > 0) {
        v.goodsLabelSize = `${v.packagePrintSizeObj.goodsWidth}*${v.packagePrintSizeObj.goodsHeight}`;
        v.conventionLabelSize = `${v.packagePrintSizeObj.conventionWidth}*${v.packagePrintSizeObj.conventionHeight}`;
        v.logisticsManifestLabelSize = `${v.packagePrintSizeObj.logisticsManifestWidth}*${v.packagePrintSizeObj.logisticsManifestHeight}`;
      } else {
        v.goodsLabelSize = null;
        v.conventionLabelSize = null;
        v.logisticsManifestLabelSize = null;
      }
      // 判断如果当前的订单类型是速卖通全托管订单，先打印速卖通全托管的货品标签，在打印面单
      if (v.orderType === 'ONE_STOP_SERVICE') {
        v.$Modal.info({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000618'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004879'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000594'),
          onOk: () => {
            v.printGoodsLabel();
          }
        });
      } else {
        // 打印商品合规标签
        if (v.isPrintComplianceLabels && v.orderComplianceLabelVerificationTalg &&
          v.matchYmsPackageInfo?.ymsPackageInfo.isProductLabelPath === 1) {
          v.print(v.productLabelPath, v.complianceLabelPackageCode, true, null, null);
          setTimeout(() => {
            // 打印面单
            v.print(v.labelPath, v.printPackageCode, true, null, null, v.conventionLabelSize);
          }, 2000)
        } else {
          // 打印面单
          v.print(v.labelPath, v.printPackageCode, true, null, null, v.conventionLabelSize);
        }
      }
    },
    // 监听回车键事件
    handleKeyDown(event) {
      if (event.key === 'Enter' && this.aliexpressChoiceTalg) {
        this.printGoodsLabel();
      }
    },
    // 打印速卖通全托管货品标签面单
    printGoodsLabel() {
      let v = this;
      v.$refs['sortingSku'].blur();
      v.aliexpressChoiceTalg = true;
      v.print(v.platformProductLabelPath, v.printPackageCode, true, null, null, v.goodsLabelSize);
      setTimeout(() => {
        v.print(v.labelPath, v.printPackageCode, true, null, null, v.logisticsManifestLabelSize);
      }, 2000);
      setTimeout(() => {
        v.$Modal.remove();
        v.aliexpressChoiceTalg = false;
        document.removeEventListener('keydown', v.handleKeyDown);
      }, 3000);
    },
    resetPackageParam() {
      let v = this;
      v.scanSkuParams.packageId = null;
      v.packageProcessStep = 0;
      v.weightStatus = true;
      v.packageCode = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004872');
    },
    cancel() {
      // 取消弹框
      let v = this;
      v.warnStatus = false;
      v.findWarnStatus = false;
      v.warnPrintStatus = false;
      v.warnMatchStatus = false;
      v.errorCode = 0;
      document.getElementById('sortingSku').focus();
    },
    print(path, postId, flag, orderBy, callback, labelSize, printType) {
      // JSONP /printResult flag是否调接口
      let v = this;
      let originPostId = postId;
      if (path) {
        printHtmlUrl(path, postId).then(res => {
          if (res.printType === 'cainiao') {
            // 菜鸟打印完成
            v.finishPrint(callback, printType);
            return;
          }
          let jsonObj = res;
          if (jsonObj.content) {
            jsonObj.content = encodeURIComponent(jsonObj.content);
          } else {
            jsonObj.pdf = encodeURIComponent(jsonObj.pdf);
          }
          let instance = v.axios.create({
            timeout: 3000,
            headers: {
              'Content-Type': 'multipart/form-data; charset=UTF-8'
            }
          });
          v.tableLoading = true;
          // 添加打印尺寸参数
          if (labelSize) {
            jsonObj.labelSize = labelSize;
          }
          delete v.axios.defaults.headers.post['X-Requested-With'];
          instance.post('http://localhost:10099/print', qs(jsonObj)).then(response => {
            v.tableLoading = false;
            if (response.status === 200) {
              v.startPrintMonitor(jsonObj, originPostId, flag, orderBy, callback, printType);
            }
          }).catch(() => {
            let fileName = '/tool/TongtoolPrinter.exe';
            downloadControl(fileName).then(() => {
              v.tableLoading = false;
            });
          });
        });
      } else {
        let text = postId.includes('HG-') ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004880') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004881');
        v.$Message.error(text);
        v.tableLoading = false;
        return false;
      }
    },
    startPrintMonitor(jsonObj, postId, flag, orderBy, callback, printType) {
      let v = this;
      let obj = {
        packageIds: [postId]
      };
      if (orderBy) {
        obj.printOrderBy = orderBy;
      }
      // jsonObj.responseType = 1;
      delete jsonObj.content;
      delete v.axios.defaults.headers.post['X-Requested-With'];
      // instance.post('http://localhost:10099/printResult?' + Qs.stringify(jsonObj))
      v.axios.jsonp('http://localhost:10099/printResult?' + qs(jsonObj)).then(response => {
        console.log(typeof response.data);
        if (response.data === '0') {
          v.clearTime = setTimeout(function () {
            v.skuInput = null;
            v.startPrintMonitor(jsonObj, postId, flag, orderBy, callback, printType);
          }, 500);
        } else if (response.data === '2') {
          document.getElementById('sortingSku').focus();
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004806'));
        } else if (flag) {
          // 不是重复打印，需要调接口
          // let param = {};
          // param.pickingGoodsId = v.pickingGoodsId;
          // param.packageId = v.scanSkuParams.packageId;
          // 打印合规标签的时候不需要调换单接口，只有打印面单的成功之后才需要调换单接口
          if (!postId.includes('HG-')) {
            v.finishPrint(callback, printType);
          }
        }
      });
    },
    finishPrint(callback, printType) {
      let v = this;
      if (printType !== 'ONE_STOP_SERVICE') {
        v.axios.put(api.put_ymsPickingOrderRelated_markChangedLabel, [v.ymsPickingOrderRelatedId]).then(response => {
          document.getElementById('sortingSku').focus();
          callback && callback();
          if (response.data.code === 0) {
            v.pickInfo.ymsPickingOrderRelatedList.forEach(i => {
              if (i.ymsPickingOrderRelatedId === v.ymsPickingOrderRelatedId) {
                i.isPrinted = 1;
                i.packedStatus = 3;
              }
            });
            v.ymsPickingOrderRelatedId = '';
            v.packageCode = '';
            v.printPackageCode = '';
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004745'));
            v.packageProcessStep = 4;
            v.resetPackageParam();
            // 扫描的sku列表清空
            v.currentPackageData = [];
            let isFinish = v.pickInfo.ymsPickingOrderRelatedList.every(i => i.packedStatus === 3);
            if (isFinish) {
              v.isOpenQuitModal();
            }
            v.$nextTick(() => {
              document.getElementById('sortingSku').focus();
            });
          }
        });
      } else {
        setTimeout(() => {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004882'));
        }, 2000);
      }
    },
    /**
     *  退出当前作业 true 直接退出
     * @date: 2021/8/20 14:12
     * @param type 1 退出当前作业 2 退出作业
     */
    isOpenQuitModal(type) {
      let v = this;
      let isBack = false;
      if (type === 1) {
        isBack = v.quitWork();
        if (isBack) {
          this.$router.push('/wms/packWorking');
        }
      } else {
        // 退出作业之前要校验出库单中是否存在有已取消的订单，如果存在取消的订单则弹出取消订单提示窗
        ymsVerifyPicking(api.put_ymsPickingOrder_checkPickingOrder, [v.pickingGoodsId]).then((list) => {
          if (list.length > 0) {
            this.$refs['orderCancelPrompt'].basicData = list;
            this.$refs['orderCancelPrompt'].orderCancelPromptModal = true;
          } else {
            let isOpen = v.pickInfo.ymsPickingOrderRelatedList.every(i => i.packedStatus === 3);
            v.getUserData().then((data) => {
              v.userData = data || [];
              if (v.userData.length > 0) {
                v.$refs.endWarnModal.isFinish = true;
                v.$refs.endWarnModal.isFinishStatus = true;
                v.$refs.endWarnModal.endStatus = isOpen;
                v.$refs.endWarnModal.initData();
              }
            });
          }
        });
      }
    },
    /**
     * 获取包装作业统计
     * @date: 2021/8/21 13:46
     */
    getUserData() {
      let v = this;
      return new Promise(resolve => {
        let data = [];
        v.getPickInfo().then(response => {
          data = response.ymsPickingOrderMembers || [];
          data.forEach(i => {
            let endTime = i.endTime ? new Date(v.$uDate.getDataToLocalTime(i.endTime, 'fulltime')).getTime() : new Date().getTime();
            let startTime = new Date(v.$uDate.getDataToLocalTime(i.startTime, 'fulltime')).getTime();
            i.userName = getUserNameByUserId(i.userId, v.userInfoList);
            i.packageTotalCount = 0;
            i.goodsTotalCount = 0;
            i.scannedTime = ((endTime - startTime) / (1000 * 60)).toFixed(2);
            response.ymsPickingOrderRelatedList.forEach(j => {
              let matchedTime = new Date(v.$uDate.getDataToLocalTime(j.matchedTime, 'fulltime')).getTime();
              if (matchedTime >= startTime && matchedTime <= endTime && i.userId === j.matchedBy) {
                i.packageTotalCount++;
                i.goodsTotalCount = j.ymsPackageInfo.ymsPackageGoods.reduce((a, b) => {
                  return a + b.quantity;
                }, i.goodsTotalCount);
              }
            });
          });
          resolve(data);
        });
      });
    },
    quitWork() {
      // 退出当前作业
      let v = this;
      return new Promise(resolve => {
        v.axios.put(api.put_ymsPickingOrder_quitPacking + v.pickingGoodsId).then(response => {
          if (response.data.code === 0) {
            resolve(true);
          }
        });
      });
    },
    changeData(val) {
      // 打印选中面单数据
      let v = this;
      v.printList = val;
    },
    printBatch(n, pos) {
      let v = this;
      if (n >= v.printList.length) {
        v.tableLoading = false;
        return pos;
      }
      let falg = true;
      if (v.printList[n].isPrinted) {
        falg = false;
      }
      v.packageIds = [v.printList[n].packageId];
      v.printObj = v.printList[n];
      v.print(v.printList[n].labelPath, v.printList[n].packageCode, falg, null, function () {
        v.printBatch(n + 1, pos);
      });
    },
    printSelect() {
      // 打印选中面单
      let v = this;
      document.getElementById('sortingSku').focus();
      if (v.printList.length) {
        v.tableLoading = true;
        v.printBatch(0, []);
        v.printStatus = true;
      } else {
        v.tableLoading = false;
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002395')); // 请选择数据
      }
    },
    hideSkuModal() {
      this.cancel();
    },
    setViewData(data, shipData) {
      this.userName = getUserNameByUserId(this.$store.state.erpConfig.userInfo.userId, this.userInfoList);
      data.ymsPickingOrderRelatedList.forEach(j => {
        if (j.ymsPackageInfo.ymsPackageGoods) {
          j.ymsPackageInfo.ymsPackageGoods.forEach(k => k.sku = k.ymsSku);
          if (shipData && shipData.length > 0) {
            shipData.forEach(s => {
              if (j.ymsPackageInfo.shippingMethodId === s.shippingMethodId) {
                j._shipInfo = {
                  ...s
                };
              }
            });
          }
        }

      });
      return data;
    },
    // 获取打印配置的数据
    getPackagePrintSizeData() {
      let v = this;
      v.packagePrintSizeObj = {};
      getCommonParamKeysData(v.userInfo.userId, ['packagePrintSize'], false, true).then((data) => {
        if (data && data.length > 0) {
          v.packagePrintSizeObj = JSON.parse(data[0].paramValue);
        }
      });
    },
    // 更新打印配置数据
    updatePrintSet(obj) {
      this.packagePrintSizeObj = obj;
    },
    // 获取包装作业的相关设置
    getPackageSetting(ymsWarehouseId) {
      this.isPrintComplianceLabels = false;
      let query = [
        {
          paramKeys: ['enablePackagingPrintComplianceLabels'],
          businessId: this.userInfo.userId + '*' + ymsWarehouseId
        }
      ];
      getCommonSetting(query).then((data) => {
        data.forEach(i => {
          if (i.paramKey === 'enablePackagingPrintComplianceLabels') {
            this.isPrintComplianceLabels = i.paramValue === 'Y';
          }
        });
      });
    }
  },
  watch: {
    // 监听sku异常的弹窗
    warnStatus: {
      handler(value) {
        let v = this;
        if (value) {
          v.$nextTick(() => {
            document.getElementById('skuAbnormal').focus();
          });
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.packingWork {
  .breadcrumb_box {
    padding: 12px 0 0 15px;
  }
}

.pickHeader {
  width: 99%;
  height: 40px;
  margin: 10px auto;
  line-height: 40px;
  background-color: rgba(247, 150, 70, 1);
}

.skuInput {
  margin-left: 10px;
  margin-top: 5px;
  margin-right: 12px;
  padding: 15px;
  background-color: rgba(43, 120, 228, 1);
}

.skuBox {
  height: 500px;
  margin-top: 10px;
  padding-top: 20px;
  margin-left: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid rgb(164, 197, 235);
}

.pickingGoods {
  width: 99%;
  margin: 10px auto;
}

.pickBox {
  width: 100px;
  height: 50px;
  margin-top: 10px;
  border: 1px solid #000;
}

.productBox {
  width: 300px;
  height: 170px;
  border: 1px solid #000;
  font-size: 24px;
  text-align: center;
  line-height: 170px;
  font-weight: bold;
}

.productInfo {
  background-color: rgb(252, 251, 225);

  .img_styles {
    vertical-align: middle;
    width: auto;
    max-width: 277px;
    height: 171px;
    cursor: pointer;
    display: inline-block;
    margin-bottom: 50px;
  }
}

.scanPackageShow {
  border: 1px solid rgb(215, 215, 215);
  margin-left: 10px;
  margin-right: 12px;
  background-color: rgb(252, 251, 225);
}

.warnBox {
  width: 80%;
  height: 400px;
  border: 1px solid #717274;
  margin-left: 5%;
  background-color: #fff;
}

.warnBtn {
  width: 200px;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
  margin-left: 40%;
  background-color: #aaa;
}

.packProcess {
  width: 700px;
  height: 50px;
  margin: 10px auto;
}

.packProcessCol {
  width: 100%;
  border-style: solid;
  margin-left: 10px;
  margin-right: 12px;
  margin-top: 15px;
  border-width: 1px;
}

.bar {
  margin-left: 10px;
  margin-top: 15px;
  margin-right: 12px;
  padding: 15px;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  background-color: rgba(43, 120, 228, 1);
}

.cleanScanLink {
  padding-right: 12px;
  float: right;
}

.orderTable {
  padding: 0 12px;
}
</style>
<style>

.packProcess .ivu-steps .ivu-steps-title {
  display: block;
}

.packProcess .ivu-steps .ivu-steps-custom .ivu-steps-title {
  margin-left: -20px;
}

.packProcess .ivu-steps-item {
  overflow: initial
}
</style>
